import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getHomePath } from "utils/common";
import { isLoginAuth } from "utils/login";

function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoginAuth()) {
      document.querySelector("hfn-auth")?.triggerAuth();
    } else {
      navigate(getHomePath());
    }
  }, []);

  return <div />;
}

export default Login;
